import styled from 'styled-components';
import breakpoints from 'bdata-sns-shared/mini/utils/miniBreakpoints';
import MiniScoreboardGame from 'bdata-react-mini-scoreboard-game-infinity/lib/components/MiniScoreboardGame';
import GameWrapper from 'bdata-sns-shared/mini/components/GameWrapper';
import { GameStateLabelWrapper, StatusLayerWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/StatusLayer/StatusLayer.style';
import COLORS from '@mlb/react-patterns/style/universal.color';
import { TeamMatchupLayerWrapper, ScoreWrapper, ScoreContainer, RowWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/TeamMatchupLayer/TeamMatchupLayer.style';
import { DesktopTeamWrapper, MobileTeamWrapper } from 'bdata-sns-shared/game/components/TeamWrappers.style';
import { GameOuterWrapper, ContentWrapper, GenericWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/MiniScoreboardGame.style';
import ClickthroughWrapper from 'bdata-sns-shared/mini/components/ClickthroughWrapper';
import { DataWrapper, SplitSquadWrapper, NameWrapper, OuterWrapper } from '@mlb/react-patterns/components/Team/team.style';
import { ActionLayerWrapper } from 'bdata-react-mini-scoreboard-game-infinity/lib/components/ActionLayer/ActionLayer.style';
import { ButtonWrapper } from 'bdata-sns-shared/utils/getProductButtons';
import { ElementHoverWrapper } from '@mlb/react-patterns/components/HoverToggle/hoverToggle.style';
import ControlledOverflow from '@mlb/react-patterns/components/ControlledOverflow/controlledOverflow';

import {
    InnerWrapper,
    LeftButton,
    RightButton,
    EndInsert
} from '@mlb/react-patterns/components/ControlledOverflow/controlledOverflow.style';
import { LinkWrapper } from 'bdata-sns-shared/mini/components/MiniScoreboardLink/MiniScoreboardLink.style';

const { mobile } = breakpoints;

const {
    mlbWhite,
    focusedBlue,
    mlbGrey2
} = COLORS;

const borderGrey = '#C4C4C4';

export const DesktopPlayoffsWrapper = styled.div`
    display: none;
`;

export const AllGamesContainer = styled.div`
    width: 100%;

    ${GenericWrapper} {
        .content-wrapper {
            border-top: 0;
            border-bottom: solid 1px ${mlbGrey2};

        }
        &:last-child {
            .content-wrapper {
                border-bottom-color: transparent !important;
                @media (hover: hover) {
                    &:hover {
                        ${({ disableCell }) => !disableCell ? 'border-bottom-color: transparent !important;' : ''}
                    }
                }
            }
        }
    }
`;

export const MiniScoreboardGameOverride = styled(MiniScoreboardGame)`

    width: ${({ theme }) => theme.width};
    height: auto;
    background: transparent;
    border-radius: ${({ theme }) => theme.borderRadius};
    position: static;
    box-sizing: border-box;

    ${ClickthroughWrapper} {
        height: auto;   
    }

    ${ElementHoverWrapper} {
        >*:last-child {
            margin-left: -1px;
        }
    }

    > div:first-child {
        height: auto;
    }

    &:hover {
        transform: none;
        box-shadow: none;
        border-radius: ${({ theme }) => theme.borderRadius};
    }
    
    border: none;
    
  
    ${ContentWrapper} {
        border-radius: ${({ theme }) => theme.borderRadius};
        height: auto;
        min-height: ${({ theme }) => theme.contentWrapper.height};
        width: ${({ theme }) => theme.contentWrapper.width};
        border: ${({ theme }) => theme.ContentBorder.visibility ? `solid ${theme.ContentBorder.borderSize} ${theme.ContentBorder.borderColor}` : 'none'};
        border-right: ${({ theme }) => theme.ContentBorder?.borderRight};
        border-left: ${({ theme }) => theme.ContentBorder?.borderLeft};

        &.selected {
            border-color: ${({ theme }) => `${theme.hoverBorderColor}`};
            box-shadow: inset 0px 0px 0px 1px ${({ theme }) => theme.hoverBorderColor};
        }
    }

    ${ClickthroughWrapper} {
        position: static;
        padding: 0;
        box-sizing: inherit;
        border: 0;
        color: ${({ theme }) => theme.ClickthroughWrapper.color};
        width: ${({ theme }) => theme.width};
        height:${({ theme }) => theme.height};
        display: inline-block;
        background: transparent;
        ${({ theme }) => `${theme?.cursor ? 'cursor:' + theme?.cursor : ''}`};
        ${({ theme }) => theme?.ClickthroughWrapper?.hoverColor && `
            &:hover {
                color: ${theme?.ClickthroughWrapper?.hoverColor};
            }
        `}
    }

    ${ActionLayerWrapper} {
        border: solid 1px ${({ theme }) => (theme.hoverBorderColor || 'transparent')};
        border-radius: ${({ theme }) => theme.borderRadius};
        pointer-events: auto;
        height: calc(100% - 2px);

        ${ButtonWrapper} {
            a {
                button {
                    height: 60px;
                    width: 60px;
                    span  {
                        display: block;
                    }
                }

                &:focus {
                    outline: 1px solid ${focusedBlue};
                }
        
            }
            &:not(:last-child) {
                &:after {
                    background-color: transparent;
                }
            }
        }
    }


    ${TeamMatchupLayerWrapper} {
        padding-right: 0px;

        ${RowWrapper} {
            height: ${({ theme }) => theme?.RowWrapper?.height};
            margin-bottom: ${({ theme }) => theme?.RowWrapper?.marginBottom};
        }

        ${DataWrapper} {
            ${({ theme }) => theme.useDesktopTeamWrapper && `
                padding-left:0;
                width: 88px;
                margin-left:10px;
                text-align: left;
                padding-top:7px;
            `
}
        }

        ${NameWrapper} {
            display: ${({ theme }) => theme.NameWrapper.display};
        }

        ${OuterWrapper} {
            margin-left: ${({ theme }) => theme?.teamMatchOuterWrapper?.marginLeft};
        }
    

        ${SplitSquadWrapper} {
            ${({ theme }) => theme.useDesktopTeamWrapper && `
                left: -5px;
            `}
        }

            ${({ theme }) => theme.useDesktopTeamWrapper && `
                > div {
                    height: 36px;
                    
                    > div:first-child {
                        > div:first-child {
                            
                            > div:first-child {
                                width: 36px;
                                height: 36px;
                                text-align: center;
                                img {
                                    margin-top: 6px;
                                }
                            }
                        }
                    }
                    
        
                    
                    @media (max-width: ${mobile}) {
                        padding-right: 0;
                        margin-top: 0;
                        > div {
                            height: 36px;
                            white-space: ${({ theme }) => theme.postseasonTheme ? 'no-wrap' : 'normal'};
                        }
                
                        > div:nth-child(2) {
                            margin-top: 0;
                        }
                    }
            `
}
    } 

    ${DesktopTeamWrapper} {
        ${({ theme }) => theme.useDesktopTeamWrapper
        ? `
            line-height: 21px;
            display: block;
            `
        : 'display: none;'
}
    }

    ${MobileTeamWrapper} {
        ${({ theme }) => theme.useMobileTeamWrapper
        ? `
            display: block;
            `
        : 'display: none;'
}
    }

    ${ScoreContainer} {
                 
        margin-right: 0;
        ${({ theme }) => theme.useMobileTeamWrapper && `
            margin-right: 0;
        `}

        ${ScoreWrapper} {
            ${({ theme }) => theme.useMobileTeamWrapper && `
            width: 31px;
            &.fave {
                width: 21px;
            }
            text-align:right;
            padding-right: 10px;
            &:empty {
                display:none;
            }
            `}

            font-size: ${({ theme }) => theme.teamScoreFontSize};
        }    
    }
    
`;

export const ControlledOverflowOverride = styled(ControlledOverflow)`
    padding-bottom: 0px;

    ${EndInsert} {
        transition-duration: .21s;
        width: ${({ endInsertWidth }) => endInsertWidth};
        padding-left: 11px;
        @media (pointer: coarse) {
            width: ${({ touchEndInsertWidth }) => touchEndInsertWidth};
        }
    }

    &.has-ps-game {
        .content-wrapper {
            min-height: 102px;
        }
    }
    
    ${LeftButton} {
        box-shadow: none;
        border: 1px solid ${borderGrey};
        svg {
            height: 12px;
        }
        &:focus {
            outline: none;
        }
    
        &:focus-visible {
            outline: 1px auto ${focusedBlue};
        }
        &:disabled {
            border-radius: 50%;
            background-color: ${mlbWhite};
            border-color: #C4C4C4;
            padding-right: 2px;
            padding-left: 0px;
            svg {
                padding-top: 0px;
                width: 20px;
                use {
                    path {
                        fill: #C4C4C4;
                    }
                }
            }
        }
    }
    ${RightButton} {
        &:disabled {
            padding-right: 0px;
            padding-left: 2px;
        }
    }

    ${GenericWrapper} {
        &:last-child {
            ${GameOuterWrapper} {
                margin-right: ${({ theme }) => theme?.gameOuterWrapper?.desktop?.lastchild?.marginRight};
            }
            @media (max-width: ${mobile}) {
                margin-right: ${({ theme }) => theme?.gameOuterWrapper?.mobile?.lastchild?.marginRight};
            } 
        }
    }

    & ${InnerWrapper} {
        opacity: 1;
        height: ${({ theme }) => theme.carouselHeight};
        overflow-y: hidden;
        justify-content: start;
        border-right: 1px solid ${borderGrey};
        scroll-padding: 0 0 0 60px;
        
        & > div {
            &:first-child {
                 ${ActionLayerWrapper} {
                    margin-left: 0px;
                 }
            }

            &[data-hidden='true'] {
                display: none;
            }
        }
        & > div {
            display: flex;
            scroll-snap-align: start;
            // Date cell + single side padding
            scroll-padding: 0 0 0 0px;
        }

        ${({ isGameday }) => !isGameday ? `
            &.snapscroll-disabled {
                scroll-snap-type: none !important;
            }

            &.snapscroll {
                scroll-snap-type: x mandatory !important;
            }

            &:after {
                display: block;
                content: '';
                position: absolute;
                left: 0;
                top: 0px;
                height: 100%;
                width: 56px;
                background-color: ${mlbWhite};
                z-index: 9;
            }
            &:before {
                display: block;
                content: '';
                position: absolute;
                left: 56px;
                top: 0px;
                height: 100%;
                width: 1px;
                background-color: #C4C4C4;
                z-index: 20;
            }
   
        ` : ''}
        

        ${LinkWrapper} {
            background-color: white;
            border: none;
            margin-left: 4px;
            ${({ theme }) => theme.useDesktopTeamWrapper &&
        `
                    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
                `
}
        }

        ${GameOuterWrapper} {
            margin: ${({ theme }) => theme?.gameOuterWrapper?.desktop?.margin || theme.gameMargin};     
            margin-top: ${({ theme }) => theme?.gameOuterWrapper?.desktop?.marginTop};

            ${GameWrapper} {
                margin-bottom: ${({ theme }) => theme?.gameWrapper?.marginBottom || '0px'};
            }

            ${StatusLayerWrapper} {
                ${({ theme }) => theme?.StatusLayerWrapper?.css};
            }

            ${GameStateLabelWrapper} {
                padding: ${({ theme }) => theme?.GameStateLabelWrapper?.padding};
            }

            @media (max-width: ${mobile}) {
                margin-top: ${({ theme }) => theme?.gameOuterWrapper?.mobile?.marginTop};
            } 

            @media (min-width: ${mobile}) {
                ${({ theme }) => theme.hoverAnimation ? `
                pointer-events: none;
                
                @keyframes moveup {
                    0% {
                        transform: translateY(0);    
                    }
                    100% {
                        transform: translateY(-4px);
                    }
                }
                @keyframes movedown {
                    0% {
                        transform: translateY(-4px);    
                    }
                    100% {
                        transform: translateY(0);
                    }
                }
                animation-fill-mode: forwards;
                animation-duration: 0.2s;

                &.unhovered {
                    animation-name: movedown;
                }

                &.hovered {
                    pointer-events:none;
                    animation-name: moveup;
                    animation-delay: 0.1s;    
                }
            ` : `
                pointer-events: auto;
                &.unhovered {
                    animation-name: none
                }
                &.hovered {
                    animation-name: none;
                    animation-delay: none;    
                }
            `}        
            }    
            
        }
    }
`;
